import {API_ROLE, API_ROLE_DEPT} from "../../const/Api";
import {RestApiMethod} from "../../const/dataEnum";
import {callAPI} from "./callApi";

const getAllRole = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_ROLE,
    });
    return res.data.data;
  } catch (error) {
    console.error('roleApi getAllRole Error:', error.message);
    return null;
  }
};

const getRoleByDeptId = async (deptId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_ROLE_DEPT}/${deptId}`,
    });
    return res.data;
  } catch (error) {
    console.error('roleApi getRoleByDeptId Error:', error.message);
    return null;
  }
};

const roleApi = {
  getAllRole,
  getRoleByDeptId
}

export default roleApi;